import Element from "../../element";

export default class RadioInput extends Element {
	constructor(props) {
		super(props);

		this.$radioButtons = null;

		this.name = props.name || null;
		this.value = null;
		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		this.$root = this.props.$root;

		if (!this.$root) {
			throw new Error('RadioInput: Root element is not defined!');
		}

		this.$radioButtons = this.$root.querySelectorAll('input[type="radio"]');

		super.init();
	}

	addEventListeners() {
		this.$radioButtons.forEach(($radio) => {
			$radio.addEventListener('change', (e) => {
				this.select($radio.value);
			});
		});
	}

	checkOption(value) {
		const $radioToCheck = Array.from(this.$radioButtons).find(($radio) => $radio.value === value);

		if (!$radioToCheck) {
			return;
		}

		$radioToCheck.checked = true;
		$radioToCheck.dispatchEvent(new Event('change'));
	}

	select(value) {
		this.value = value;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	uncheckAll() {
		this.$radioButtons.forEach(($radio) => {
			$radio.checked = false;
			$radio.removeAttribute('checked');
		});

		this.value = null;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}
}